export * from "./message/index";
export * from "./pagination/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/index.js
// module id = 469
// module chunks = 0